<app-base-modal *transloco="let t; read: 'signature_input.modal'">
  <div class="header">
    {{t('title')}}

    <div class="sr-only" [innerHTML]="t('sr_only.introduction')"></div>
  </div>

  <div class="content flex-shrink-0 flex-grow-1">
    <pl-tabs #tabs
             (tabchange)="tabChange()"
             [initialTabName]="initialTabName"
             tabPanedId="tabPanelSignatureModal">
      <div class="tabs" role="tablist">
        @if (!disabledSignatureModalTabs.includes(SignatureModalTabs.stored) && !!participant?.allow_stored_signature_image_use && participant?.stored_signature_image?.default_url != null) {
          <button [plTabHeader]="SignatureModalTabs.stored"
                  role="tab"
                  [attr.aria-controls]="tabs.tabPanedId"
                  class="btn btn-link btn-underline flex-shrink-0"
                  type="button">
            {{t('tabs.stored.header')}}
            <span class="sr-only">{{t('sr_only.stored_header')}}</span>
          </button>
        }

        @if (!disabledSignatureModalTabs.includes(SignatureModalTabs.typed)) {
          <button [plTabHeader]="SignatureModalTabs.typed"
                  role="tab"
                  [attr.aria-controls]="tabs.tabPanedId"
                  class="btn btn-link btn-underline"
                  type="button">
            {{t('tabs.type.header')}}
            <span class="sr-only">{{t('sr_only.typed_header')}}</span>
          </button>
        }

        @if (!disabledSignatureModalTabs.includes(SignatureModalTabs.drawn)) {
          <button [plTabHeader]="SignatureModalTabs.drawn"
                  role="tab"
                  [attr.aria-controls]="tabs.tabPanedId"
                  class="btn btn-link btn-underline"
                  type="button">
            {{t('tabs.draw.header')}}
            <span class="sr-only">{{t('sr_only.draw_header')}}</span>
          </button>
        }

        @if (!disabledSignatureModalTabs.includes(SignatureModalTabs.uploaded)) {
          <button [plTabHeader]="SignatureModalTabs.uploaded"
                  role="tab"
                  [attr.aria-controls]="tabs.tabPanedId"
                  class="btn btn-link btn-underline"
                  type="button">
            {{t('tabs.upload.header')}}
            <span class="sr-only">{{t('sr_only.upload_header')}}</span>
          </button>
        }

        @if (tabs.activeTabName === 'typed') {
          <pl-signature-font-selector
            [ngModel]="selectedFont"
            (ngModelChange)="selectFont($event)"
            [signatureText]="user?.name ?? participant?.name"
            class="ml-auto d-none d-sm-inline-block" />
        }

        @if (tabs.activeTabName !== 'stored' && tabs.activeTabName !== 'typed') {
          <button (click)="reset(); resetSignatureStore()"
                  class="ml-auto btn btn-sm btn-link text-danger d-none d-sm-flex"
                  type="button">
            {{t('reset')}}
          </button>
        }

        <div class="mobile-landscape-signature pl-2">
          <ng-container *ngTemplateOutlet="submitButton"></ng-container>
        </div>
      </div>

      <ng-template [plTabBody]="SignatureModalTabs.stored">
        <div class="info">
          <span>{{t('preview')}}</span>
        </div>
        <div class="outer-signature-container stored">
          <img [src]="participant?.stored_signature_image?.default_url" class="signature-container">
        </div>
      </ng-template>
      <ng-template [plTabBody]="SignatureModalTabs.typed">
        <div class="info">
          <span>{{t('preview')}}</span>
          @if (tabs.activeTabName === 'typed') {
            <pl-signature-font-selector
              [ngModel]="selectedFont"
              (ngModelChange)="selectFont($event)"
              [signatureText]="user?.name ?? participant?.name"
              class="ml-auto d-inline-block" />
          }
        </div>
        <div class="outer-signature-container">
          <pl-typed-signature-pad
            [signatureText]="user?.name ?? participant?.name ?? ''"
            class="signature-container" />
        </div>
      </ng-template>
      <ng-template [plTabBody]="SignatureModalTabs.drawn">
        <div class="info">
          <span>{{t('sign_with_finger')}}</span>
          <button (click)="reset(); resetSignatureStore()"
                  class="ml-auto btn btn-sm btn-link text-danger d-flex"
                  type="button">
            {{t('reset')}}
          </button>
        </div>
        <div class="outer-signature-container">
          <pl-signature-pad #pad class="signature-container" />
        </div>
      </ng-template>
      <ng-template [plTabBody]="SignatureModalTabs.uploaded">
        <div class="info">
          @if (localFile) {
            <span>{{t('preview')}}</span>
          } @else {
            <span>{{t('choose_image')}}</span>
          }

          <button (click)="reset(); resetSignatureStore()"
                  class="ml-auto btn btn-sm btn-link text-danger d-flex"
                  type="button">
            {{t('reset')}}
          </button>
        </div>
        <div class="outer-signature-container">
          <div class="signature-container">
            <app-file-picker (fileChange)="onFile($event)"
                             [appearance]="'button'"
                             [file]="localFile ?? selectedFile"
                             [formatDisplay]="['png', 'jpeg']"
                             [mimeTypes]="['image/png', 'image/jpeg']"
                             [hideDropInfo]="true"
                             appearance="block">
              @if (localFile) {
                <img [src]="localFile" style="width: 100%; height: 100%; object-fit: contain">
              }
            </app-file-picker>
          </div>
        </div>
      </ng-template>
    </pl-tabs>
    <div class="small text-muted d-block d-md-none mx-3 mx-sm-0 mt-2">
      {{t('law_info')}}
    </div>
  </div>

  <div class="footer d-flex flex-row align-items-center justify-content-between flex-shrink-1">
    <div class="small text-muted pr-2 my-2 mr-auto d-none d-md-block">
      {{t('law_info')}}
    </div>
    <div class="d-flex flex-row align-items-center ml-auto flex-shrink-0">
      <button (click)="baseModalService.close()" class="flex-grow-0 btn btn-light mr-2" type="button">
        {{t('cancel')}}
      </button>
      <ng-container *ngTemplateOutlet="submitButton"></ng-container>
    </div>
  </div>

  <ng-template #submitButton>
    <button (click)="sign()"
            class="flex-grow-0 flex-shrink-0 btn btn-primary"
            type="button">

      @if (tabs.activeTabName !== 'stored') {
        {{t('sign')}}
      } @else {
        {{t('use')}}
      }
    </button>
  </ng-template>
</app-base-modal>
